<template>
  <section class="relative pb-0 mb-0 bg-summer-yellow">
    <div class="w-full h-full overflow-hidden absolute">
      <div
        class="huge-circle bg-background-yellow rounded-full absolute left-1/2 transform -translate-x-2/4 translate-y-0"
      />
    </div>

    <div class="container py-12 m:py-16 flex flex-col justify-center items-center">
      <b-headline type="h2" typography="h2" class="mb-5 m:mb-1 text-center z-50" v-html="$t('headline')" />

      <b-subheadline class="z-50 mb-8 text-center" v-html="$t('description')" />

      <people-spider-image />

      <join-button class="z-10 mt-8" :login-path="loginPath" :signup-path="signupPath" />
    </div>
  </section>
</template>

<script>
import JoinButton from "./join-button"
import PeopleSpiderImage from "@/pages/spaces/join-page/components/people-spider-image"
import BHeadline from "@/component-library/b-headline"
import BSubheadline from "@/component-library/b-subheadline"

export default {
  name: "PeopleSpider",
  components: {
    PeopleSpiderImage,
    JoinButton,
    BHeadline,
    BSubheadline
  },
  props: {
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Connect to curious minds",
        description: "Discover new insights and learn together with Blinkist Spaces"
      },
      de: {
        headline: "Verbinde dich mit anderen Neugierigen",
        description: "Lerne Neues und erlebe gemeinsame Aha-Momente mit Blinkist Spaces"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.huge-circle {
  top: 48%;

  width: 200vw;
  height: 200vw;

  @include media(min-width, m) {
    top: 42%;
  }
}
</style>
